import classNames from "classnames";
import { AnchorProps, ButtonProps } from "types";
import "./buttons.scss";

export interface PlainButtonProps
  extends ButtonProps,
    Pick<AnchorProps, "href" | "target"> {
  color?: string;
  isLink?: boolean;
}

export const PlainButton = ({
  children,
  variant = "light",
  size = "standard",
  isLink,
  href,
  className,
  ...props
}: PlainButtonProps) =>
  isLink ? (
    <a
      className={classNames("button link", variant, size, className)}
      href={href}
    >
      {children}
    </a>
  ) : (
    <button
      className={classNames("button", variant, size, className)}
      {...props}
    >
      {children}
    </button>
  );
